<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500"
  >
    <v-card v-if="scene !== undefined">
      <v-card-title class="mb-2">Edit point</v-card-title>
      <v-card-text class="pt-1">
        <v-row>
          <v-col cols="12" sm="12">
            <v-text-field
              :disabled="loading"
              v-model="scene.name"
              label="Name"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12">
            <v-textarea
              :disabled="loading"
              v-model="scene.description"
              label="Description"
              clearable
              rows="3"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="red darken-1"
          text
          @click="remove">Remove</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="darken-1"
          text
          @click="cancel">Cancel</v-btn>
        <v-btn
          color="green darken-1"
          text
          @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'SceneDialog',
  props: {
    scenes: Array
  },
  data: () => ({
    loading: false,
    scene: undefined,
    dialog: false,
    resolve: null,
    reject: null
  }),
  methods: {
    open (scene) {
      this.dialog = true
      this.scene = { ...scene }
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    save () {
      this.resolve(this.scene)
      this.dialog = false
    },
    cancel () {
      this.resolve('cancel')
      this.dialog = false
    },
    remove () {
      this.resolve('remove')
      this.dialog = false
    }
  }
}
</script>

<style scoped lang="scss">

</style>
